import React from 'react';
import WillingnessToPay from '../components/WillingnessToPay';

function WillingnessToPayPage() {
  return <WillingnessToPay />;
}

export default WillingnessToPayPage;
